import React, { useState, useEffect } from "react";
import PricingHeader from "../../components/Layouts/PricingHeader";
import Header from "../../components/Layouts/Header";
import Pricing from "../../components/BuyCredit/Pricing";
import BottomBar from "../../components/Layouts/BottomBar";
import PricingFooter from "../../components/Layouts/PricingFooter";
import PremiumLoader from "../../components/Loader/PremiumLoader";

const BuyCredits = () => {
  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <div>
        <Header />
        <Pricing />
      </div>
      <div style={{ marginTop: "auto" }}>
        <BottomBar className="bottom-bar-spacing" />
        <PricingFooter />
      </div>
    </div>
  );
};

export default BuyCredits;
